<template>
    <div class="IconTextRowWrapper">
        <div v-if="variant === 'default'" class="IconTextRow">
            <img v-if="image" class="size-6 rounded-full" :src="image" />

            <CIcon v-else-if="icon" class="size-6 text-gray-840 dark:text-txt-headings" :name="icon" />

            <div
                class="self-center"
                :class="{
                    '-pb-[1.25rem] ml-1.5 text-sm': slim,
                    'ml-3 mt-0.5 leading-snug': !slim,
                    'cut-lines': limitLines
                }"
                :style="limitLines ? `-webkit-line-clamp: ${limitLines}` : ''"
                :title="fullText"
            >
                <slot />
            </div>
        </div>
        <div v-if="variant === 'bigger'" class="IconTextRow">
            <img v-if="image" class="size-10 rounded-full" :src="image" />

            <CIcon v-else-if="icon" class="size-10 text-gray-840 dark:text-txt-headings" :name="icon" />

            <div class="self-center text-lg leading-none" :class="slim ? 'text-sm' : 'mt-0.5 ml-3 leading-snug'">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    icon?: string
    image?: string
    slim?: boolean
    variant?: string
    limitLines?: number
    fullText?: string
}>(), {
  icon: undefined,
  image: undefined,
  variant: 'default',
  limitLines: undefined,
  fullText: undefined
})
</script>

